import { DeleteFilled, EditOutlined } from "@ant-design/icons";
import {
  Button,
  Col,
  Pagination,
  Row,
  Space,
  Table,
  Switch,
  Tooltip,
  Typography,
} from "antd";
import _ from "lodash";
import React, { useCallback, useContext, useEffect, useState } from "react";
import NotFound from "../../../../components/common/notFound";
import useAuth from "../../../../lib/hooks/useAuth";
import { MONTH, SUCCESS_CODE } from "../../../../lib/const";
import { SearchIndicatorContext } from "../searchContext";
import { routes } from "../../../../routes";
import { useNavigate } from "react-router-dom";
import {
  deleteIndicators,
  getIndicatorsListData,
  searchIndicators,
  updateIndicatorsData,
} from "../../../../services/progressPerformance";
import ConfirmModal from "../../../../components/modal/confirmModal";
import SuccessModal from "../../../../components/modal/successModal";
import FailModal from "../../../../components/modal/failModal";

const { Text } = Typography;

const Content = ({ roleUser }) => {
  const navigate = useNavigate();
  const { auth } = useAuth();
  const [dataSource, setDataSource] = useState([]);
  const {
    searchValues,
    setSearchValues,
    pageValues,
    setPageValues,
    search,
    setSearch,
  } = useContext(SearchIndicatorContext);
  let [no, setNo] = useState(0);

  const [confirmModal, setConfirmModal] = useState({
    type: "",
    show: false,
    id: 0,
  });

  const [successModal, setSuccessModal] = useState(false);
  const [failModal, setFailModal] = useState(false);

  const createPermission =
  auth?.user?.permissions &&
  _.get(
    auth?.user?.permissions.find(
      (item) => item.permissionName === "Application field"
    ),
    "permissionList",
    []
  ).find(
    (item) => item.pageName === "รายงานผลตัวชี้วัด" && _.get(item,"customPermission['Create/Update']",false) === true
  );

  const viewPermission =
  auth?.user?.permissions &&
  _.get(
    auth?.user?.permissions.find(
      (item) => item.permissionName === "Application field"
    ),
    "permissionList",
    []
  ).find(
    (item) => item.pageName === "รายงานผลตัวชี้วัด" && _.get(item,"isView",false) === true
  );

  const fetchIndicators = useCallback(
    async (searchValues, pageValues) => {
      const res = await searchIndicators(searchValues, pageValues);
      const { objectValue, pageValue } = res.data;
      if (res?.data?.code === SUCCESS_CODE) {
        let _p =
          parseInt(pageValues.page) === 0
            ? parseInt(pageValues.page)
            : parseInt(pageValues.page) * pageValues.pageSize;
        setNo(_p);
        setDataSource(objectValue);
        // setSearchValues(objectValue);
        setPageValues(pageValue);
      } else {
        setDataSource([]);
        setPageValues((prev) => ({
          ...prev,
          page: 0,
          pageSize: 10,
          total: 0,
          totalPage: 0,
        }));
      }
    },
    [setDataSource, setSearchValues, setPageValues]
  );

  const columns = [
    {
      align: "right",
      title: "ลำดับ",
      dataIndex: "no",
      key: "no",
      render: (_, record) => <span>{(no += 1)}</span>,
    },
    {
      width: 200,
      title: "ฝ่าย",
      dataIndex: "departmentNameTh",
      key: "departmentId",
      sorter: (a, b) => a.departmentNameTh - b.departmentNameTh,
    },
    {
      width: 350,
      title: "กอง",
      dataIndex: "divisionNameTh",
      key: "divisionId",
      sorter: (a, b) => a.divisionNameTh - b.divisionNameTh,
    },
    // {
    //   width: 200,
    //   title: "ประจำเดือน",
    //   dataIndex: "monthOfBudget",
    //   key: "monthOfBudget",
    //   sorter: (a, b) => a.monthOfBudget - b.monthOfBudget,
    //   render: (_, record) => (
    //     <Text>
    //       {MONTH[record.monthOfBudget - 1] + " " + record.yearOfBudget}
    //     </Text>
    //   ),
    // },
    {
      width: 200,
      title: "ปีงบประมาณ",
      dataIndex: "yearOfBudget",
      key: "yearOfBudget",
      sorter: (a, b) => a.yearOfBudget - b.yearOfBudget,
      render: (_, record) => <Text>{record.yearOfBudget}</Text>,
    },
    {
      width: 200,
      title: "เดือนงบประมาณ",
      dataIndex: "monthOfBudget",
      key: "monthOfBudget",
      sorter: (a, b) => a.monthOfBudget - b.monthOfBudget,
      render: (_, record) => <Text>{MONTH[Number(record.monthOfBudget)]}</Text>,
    },
    {
      width: 400,
      title: "ผลค่าตัวชี้วัดประจำเดือน",
      dataIndex: "monthlyValue",
      key: "monthlyValue",
      sorter: (a, b) => a.monthlyValue - b.monthlyValue,
    },
    {
      width: 250,
      title: "คาดการณ์ ผลตัวชี้วัด ณ สิ้นไตรมาส",
      dataIndex: "quarterlyForecast",
      key: "quarterlyForecast",
      sorter: (a, b) => a.quarterlyForecast - b.quarterlyForecast,
    },
    {
      width: 250,
      title: "คาดการณ์ ผลตัวชี้วัด ณ สิ้นปีงบประมาณ",
      dataIndex: "annualForecast",
      key: "annualForecast",
      sorter: (a, b) => a.annualForecast - b.annualForecast,
    },
    {
      width: 120,
      align: "center",
      title: "สถานะ",
      dataIndex: "status",
      key: "status",
      sorter: (a, b) => a.status - b.status,
      render: (_, record) => (
        <Switch
          checked={record.status ? true : false}
          disabled={!createPermission}
          onChange={() =>
            setConfirmModal({
              type: "change_status",
              show: true,
              id: record.id,
              status: record.status,
              data: record,
            })
          }
        />
      ),
    },
    {
      width: 120,
      align: "center",
      title: "การจัดการ",
      dataIndex: "management",
      key: "management",
      render: (_, record) => (
        <Space>
          <Tooltip placement="bottom" title={"แก้ไข"}>
            <Button
              style={{ backgroundColor: "#FEF1DF", border: 0 }}
              shape="circle"
              onClick={() => navigate(routes.edit_indicator + "/" + record.id)}
              disabled={!createPermission && !viewPermission}
            >
              <EditOutlined style={{ color: "#F79009" }} />
            </Button>
          </Tooltip>
          <Tooltip placement="bottom" title={"ลบ"}>
            <Button
              style={{ backgroundColor: "#FDE7E5", border: 0 }}
              shape="circle"
              disabled={!createPermission}
              onClick={() => {
                setConfirmModal({
                  type: "delete",
                  show: true,
                  id: record.id,
                });
              }}
            >
              <DeleteFilled style={{ color: "#F04438" }} />
            </Button>
          </Tooltip>
        </Space>
      ),
    },
  ];

  useEffect(() => {
    if (search) {
      fetchIndicators(searchValues, pageValues);
      setSearch(false);
    }
  }, [fetchIndicators, searchValues, pageValues, search, setSearch]);

  const handleDelete = async () => {
    const res = await deleteIndicators(confirmModal.id);
    if (res.data.code === SUCCESS_CODE) {
      setSuccessModal(true);
      setSearch(true);
    } else {
      setFailModal(true);
    }
    setTimeout(() => {
      setFailModal(false);
      setSuccessModal(false);
    }, 2000);
    setConfirmModal({
      show: false,
      id: 0,
      type: "",
    });
  };

  const handleStatusChange = async () => {
    const request = Object.assign({}, confirmModal?.data, {
      status: confirmModal?.status ? "false" : "true",
    });

    const res = await updateIndicatorsData(confirmModal?.id, request);
    if (res?.data?.code === SUCCESS_CODE) {
      setSearch(true);
    } else {
      setSearch(true);
    }
    setConfirmModal({
      type: "",
      show: false,
      id: 0,
    });
  };

  const onSorter = (pagination, filters, sorter) => {
    setSearch(true);
    setPageValues((prev) => ({
      ...prev,
      sortBy: sorter && sorter.order ? sorter.columnKey : "currentCustomerId",
      sortDirection:
        sorter && sorter.order
          ? sorter.order === "ascend"
            ? "ASC"
            : "DESC"
          : "ASC",
    }));
  };

  const onPageChange = (page, pageSize) => {
    setNo(no + pageSize);
    setSearch(true);
    setPageValues((prev) => ({
      ...prev,
      page: page - 1,
      pageSize: pageSize,
    }));
  };

  const fetchIndicatorsListData = useCallback(async () => {
    try {
      const res = await getIndicatorsListData();
      if (res.data.code === SUCCESS_CODE) {
        let result_data = res.data.objectValue;
        setDataSource(result_data);
      }
    } catch (error) {}
  }, []);

  useEffect(() => {
    fetchIndicatorsListData();
  }, [fetchIndicatorsListData]);

  return (
    <div style={{ marginTop: 20 }}>
      <p style={{ margin: "30px 0 10px 0", fontWeight: 500 }}>
        รายการทั้งหมด{" "}
        <span className="pr-purple" style={{ fontWeight: 700 }}>
          {pageValues.total}
        </span>{" "}
        รายการ
      </p>

      <Row gutter={[16, 16]}>
        <Col span={24}>
          <Table
            locale={{ emptyText: <NotFound /> }}
            rowKey={"key"}
            dataSource={dataSource}
            columns={columns}
            scroll={{
              x: 1300,
            }}
            pagination={false}
            onChange={onSorter}
          />
        </Col>
        <Col span={24} align="right">
          <Pagination
            showSizeChanger
            defaultCurrent={pageValues.page + 1 || 1}
            total={pageValues.total || 10}
            onChange={onPageChange}
            showTotal={(total) => `รวม ${total} รายการ`}
          />
        </Col>
      </Row>

      <ConfirmModal
        actionType={"delete"}
        title={"ยืนยันการลบข้อมูล"}
        modalText={"คุณต้องการลบข้อมูล ?"}
        open={confirmModal.type === "delete" ? confirmModal.show : false}
        onOk={() => {
          handleDelete();
        }}
        onCancel={() => {
          setConfirmModal({
            type: "",
            show: false,
            id: 0,
          });
        }}
      />
      <ConfirmModal
        actionType={""}
        title={"ยืนยันการเปลี่ยนสถานะ"}
        modalText={`คุณต้องการเปลี่ยนสถานะเป็น  ${
          confirmModal.status ? "“ระงับการใช้งาน”" : "“กำลังใช้งาน”"
        } ใช่ไหม ?`}
        open={confirmModal.type === "change_status" ? confirmModal.show : false}
        onOk={() => {
          handleStatusChange();
        }}
        onCancel={() => {
          setConfirmModal({
            type: "",
            show: false,
            id: 0,
          });
        }}
      />
      <SuccessModal
        open={successModal}
        setOpen={setSuccessModal}
        title={"สำเร็จ"}
        subTitle={"ทำรายการสำเร็จ"}
      />
      <FailModal open={failModal} setOpen={setFailModal} />
    </div>
  );
};

export default Content;
